import {
  BOOT_ONLINE_INITIAL_PROGRESS,
  BOOT_OFFLINE_INITIAL_PROGRESS,
  PRELOGIN_STAGE_LABELS,
} from "../config/bootConfig";

export { PRELOGIN_STAGE_LABELS };

export function getInitialLoginReady(isOnline) {
  return !isOnline;
}

export function getInitialPreloginStage(isOnline) {
  return isOnline ? "checking-version" : "offline-ready";
}

export function getInitialPreloginProgress(isOnline) {
  return isOnline ? BOOT_ONLINE_INITIAL_PROGRESS : BOOT_OFFLINE_INITIAL_PROGRESS;
}
